import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  MenuItem,
  Modal,
  Select,
  Slide,
  TextField,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useState, forwardRef, useCallback, useEffect } from "react";
import { Eye, SuggestedReviewers, SmallEye } from "../Icon";
import { RefereeAnswers } from "../../Constants";
import SuggestedReviewer from "./SuggestedReviewer";
import { useLoading } from "../../../../providers/loadingProvider";
import service from "../../Helpers/gifservices";
import { Info } from "@material-ui/icons";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ABSTRACT_FILE_NAME = "propabstract";

const declineReasons = [
  { label: "Not in My Field", value: RefereeAnswers.NotInMyField },
  { label: "Too Busy", value: RefereeAnswers.TooBusy },
  { label: "Conflict of Interest", value: RefereeAnswers.ConflictOfInterests },
  { label: "Sabbatical", value: RefereeAnswers.Sabbatical },
  { label: "Emeritus", value: RefereeAnswers.Emeritus },
  { label: "Medical Reasons", value: RefereeAnswers.MedicalReasons },
  { label: "Parental Leave", value: RefereeAnswers.ParentalLeave },
  { label: "Retired", value: RefereeAnswers.Retired },
  { label: "Other", value: RefereeAnswers.Other },
];

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: "75%",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #000",
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    // margin:"0 auto 0 auto",
    top: `30%`,
    left: `25%`,
    transform: `translate(-15%, -25%)`,
    // maxHeight:700,
  },
  typography: {
    color: "#0A46F0",
    fontWeight: 600,
  },
  secoundTypography: {
    color: "#4B4B4B",
    fontWeight: 600,
    marginRight: 20,
  },
  thirdTypography: {
    color: "#4B4B4B",
    fontWeight: 400,
    marginRight: 5,
  },
  inline: {
    display: "inline-block",
  },
  icon: {
    position: "relative",
    top: 9,
  },
  button: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
    marginRight: 10,
    float: "right",
    width: "42%",
    borderRadius: 8,
  },
  acceptButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.green.hover,
    },
    color: "#FFFFFF",
    backgroundColor: theme.palette.gif.green.dark,
    float: "right",
    width: 120,
    marginTop: 10,
    marginLeft: 6,
    borderRadius: 8,
  },
  declineButton: {
    float: "right",
    width: 120,
    marginTop: 10,
    borderRadius: 8,
  },
  declineOkButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.hover,
    },
    color: theme.palette.gif.blue.color,
    backgroundColor: theme.palette.gif.blue.background,
    float: "right",
    width: 120,
    marginTop: 10,
    marginLeft: 6,
    borderRadius: 8,
  },
  declineSelect: {
    width: "80%",
    height: 40,
  },
  declineDetails: {
    marginTop: 10,
  },
  dialog: {
    height: 700,
  },
}));

export default function NewProposal(props) {
  const classes = useStyles();
  const loading = useLoading();
  const { proposalReferee, acceptProposal, declineProposal } = props;
  const [suggestReviewersOpen, setSuggestReviewersOpen] = useState(false);
  const [declineDialogOpen, setdeclineDialogOpen] = useState(false);
  const [requiredDetails, setRequiredDetails] = useState(false);
  const [details, setDetails] = useState();
  const [hasAbstract, setHasAbstract] = useState(false);

  const [declineReason, setDeclineReason] = useState("");

  const handleChange = (event) => {
    var declineReason = event.target.value;
    if (declineReason === RefereeAnswers.Other) {
      setRequiredDetails(true);
    } else {
      setRequiredDetails(false);
    }
    setDeclineReason(declineReason);
  };

  const getFiles = useCallback(async () => {
    const proposalId = proposalReferee?.proposalId;
    if (!proposalId) return;
    const loadingId = loading.addLoading("fetching data");
    var files = await service.getProposalFiles({ proposalId });
    const abstract = files.filter(
      (f) => f.name === `${proposalId}_${ABSTRACT_FILE_NAME}.pdf`
    );
    if (abstract.length > 0) setHasAbstract(true);
    loading.removeLoading(loadingId);
  }, [loading, proposalReferee?.proposalId]);

  const requiredDetailsChange = (event) => {
    setDetails(event.target.value);
  };

  const getGeneralInfo = async () => {
    const loadingId = loading.addLoading("Downloading General Information");
    const data = await service.downloadRawFile({
      path: "RefereesDocuments/GIF Nexus 2024.pdf",
    });
    if (!(data instanceof Blob)) {
      loading.removeLoading(loadingId);
      return;
    }
    const blob = new Blob([data], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `abstract.pdf`;
    link.click();
    loading.removeLoading(loadingId);
  };
  const getProposalAbstract = async (proposalId) => {
    const loadingId = loading.addLoading("Downloading Abstract");
    var data = await service.downloadProposalFiles({
      id: proposalId,
      fileName: `${ABSTRACT_FILE_NAME}.pdf`,
    });
    if (!(data instanceof Blob)) {
      return;
    }
    const blob = new Blob([data], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `abstract.pdf`;
    link.click();
    loading.removeLoading(loadingId);
  };

  useEffect(() => {
    getFiles();
  }, [getFiles]);

  return (
    <>
      <Modal open={suggestReviewersOpen}>
        <Box>
          <SuggestedReviewer
            proposalId={proposalReferee?.proposalId}
            openCloseSuggestedReviewers={() => setSuggestReviewersOpen(false)}
          />
        </Box>
      </Modal>
      <Box border="2px #C4C4C4 solid" padding={2}>
        <Typography className={classes.typography}>New Proposal</Typography>
        {proposalReferee ? (
          <Box>
            <Typography className={classes.secoundTypography}>
              {proposalReferee.proposalTitle}
            </Typography>
            <Box sx={{ display: "flex", marginY: 2 }}>
              <Button
                disabled={!hasAbstract}
                disableElevation
                variant="contained"
                className={classes.button}
                startIcon={hasAbstract ? <SmallEye /> : null}
                onClick={() => {
                  if (hasAbstract)
                    getProposalAbstract(proposalReferee.proposalId);
                }}
              >
                {hasAbstract ? "View Abstract" : "No Abstract"}
              </Button>

              <Button
                disableElevation
                variant="contained"
                className={classes.button}
                startIcon={<Info />}
                onClick={() => {
                  getGeneralInfo();
                }}
              >
                General Information About The Program
              </Button>
              <Button
                disableElevation
                variant="contained"
                className={classes.button}
                startIcon={<SuggestedReviewers />}
                onClick={() => setSuggestReviewersOpen(!suggestReviewersOpen)}
              >
                Suggest Reviewers
              </Button>
            </Box>
            <Grid item xs={12}>
              <Typography
                className={`${classes.thirdTypography} ${classes.inline}`}
              >
                Program
              </Typography>
              <Typography
                className={`${classes.secoundTypography} ${classes.inline}`}
              >
                {proposalReferee.proposalProgramtypeName}
              </Typography>
              <Typography
                className={`${classes.thirdTypography} ${classes.inline}`}
              >
                Propposal ID
              </Typography>
              <Typography
                className={`${classes.secoundTypography} ${classes.inline}`}
              >
                {proposalReferee.proposalName}
              </Typography>
            </Grid>
          </Box>
        ) : (
          <Box height={100} textAlign="center" padding={1}>
            <Eye />
            <Typography className={classes.secoundTypography}>
              No current review request
            </Typography>
          </Box>
        )}
      </Box>
      {proposalReferee ? (
        <>
          <Button
            disableElevation
            variant="contained"
            className={classes.acceptButton}
            onClick={() => acceptProposal(proposalReferee.itemID)}
          >
            Accept
          </Button>
          <Button
            disableElevation
            variant="contained"
            className={classes.declineButton}
            onClick={() => setdeclineDialogOpen(true)}
          >
            Decline
          </Button>
        </>
      ) : (
        <></>
      )}
      <Dialog
        className={classes.dialog}
        open={declineDialogOpen}
        TransitionComponent={Transition}
      >
        <DialogTitle>Decline Review</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please select a reason for declining our invitation. This will guide
            us in future selection processes. It will also assist us greatly if
            you might suggest a reviewer(s).
          </DialogContentText>
          <Select
            value={declineReason}
            onChange={handleChange}
            className={classes.declineSelect}
          >
            {declineReasons.map((reason) => (
              <MenuItem key={reason.value} value={reason.value}>
                {reason.label}
              </MenuItem>
            ))}
          </Select>
          {requiredDetails ? (
            <TextField
              className={classes.declineDetails}
              label="Reason for decline"
              size="small"
              onChange={requiredDetailsChange}
              fullWidth={true}
            />
          ) : (
            <></>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            disableElevation
            variant="contained"
            className={classes.declineButton}
            onClick={() => setdeclineDialogOpen(false)}
          >
            Cancel
          </Button>
          <Button
            disableElevation
            variant="contained"
            disabled={declineReason === ""}
            className={classes.declineOkButton}
            onClick={() => {
              setdeclineDialogOpen(false);
              declineProposal(proposalReferee.itemID, declineReason, details);
            }}
          >
            OK, Decline
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
